import i18next from 'i18next'
import {inject, injectable} from 'inversify'
import {action, makeObservable, observable, runInAction} from 'mobx'
import {CreatePayLinkRequest, editLink, PaymentLink} from '@/api'
import {openErrorNotification, openSuccessNotification} from '@/utils'
import {PayByLinkEditPaymentLinkModalContainerStoreSymbol} from '@/pages/PayByLink'
import {TEditPaymentLinkStore} from '~/code/pages/PayByLink/components/EditPaymentLinkModal'
import {TModalContainerStore} from '@/components/containers/ModalContainer/TModalContainerStore'

@injectable()
export class EditPaymentLinkStore implements TEditPaymentLinkStore {
    private readonly _editPaymentLinkModalStore: TModalContainerStore

    constructor(
        @inject(PayByLinkEditPaymentLinkModalContainerStoreSymbol)
        editPaymentLinkModalStore: TModalContainerStore
    ) {
        this._editPaymentLinkModalStore = editPaymentLinkModalStore

        makeObservable(this, {
            isLoading: observable,
            paymentLink: observable,
            editPaymentLink: action.bound,
            closeEditLinkModal: action.bound,
            openEditModal: action.bound
        })
    }

    public isLoading = false
    public paymentLink: PaymentLink = {} as PaymentLink

    public closeEditLinkModal() {
        this._editPaymentLinkModalStore.setOpen(false)
    }

    public openEditModal(paymentLink: PaymentLink) {
        this.paymentLink = paymentLink
        this._editPaymentLinkModalStore.setOpen(true)
    }

    public async editPaymentLink(id, values: CreatePayLinkRequest) {
        this.isLoading = true
        try {
            const {error} = await editLink(id, values)

            runInAction(() => {
                if (error) {
                    return openErrorNotification(error.message)
                }

                this.closeEditLinkModal()

                return openSuccessNotification(i18next.t('pay-by-link.linkSaved'))
            })
        } catch (error) {
            return openErrorNotification(i18next.t('globals:errors.general'))
        } finally {
            this.isLoading = false
        }
    }
}
